import { useQuery } from "react-query";
import { getActiveOrganizationsForAssignee } from "./gateway";

export const useGetActiveOrganizationsForAssignee = (enabled: boolean) => {
  return useQuery({
    queryFn: () => getActiveOrganizationsForAssignee(),
    queryKey: ["getActiveOrganizationsForAssignee"],
    enabled,
  });
};
